import { Crown } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * Aviso de función bloqueada por plan, específico para WhatsApp.
 * Mismo look que el resto del dashboard usa para features de pago (Crown +
 * fondo ámbar + CTA "Mejorar mi plan"), ver también components/UpgradeRequired.tsx
 * y el bloque needsUpgrade de pages/VoiceAI.tsx::StatusTab.
 *
 * A diferencia de UpgradeRequired (bloquea la página ENTERA a pantalla
 * completa), este componente es una card pensada para incrustarse dentro de
 * una sección de una página con más contenido (Notifications.tsx, Integration.tsx).
 */
export default function WhatsAppUpgradeNotice() {
  return (
    <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 md:p-5 flex items-start gap-3">
      <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
        <Crown className="w-5 h-5 text-amber-600" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-amber-900">
          WhatsApp disponible solo en los planes de pago (Pro y Ultimate)
        </p>
        <p className="text-xs text-amber-700 mt-1">
          Actualiza tu plan para enviar confirmaciones y recordatorios de
          reserva por WhatsApp a tus clientes.
        </p>
        <Link
          to="/subscription"
          className="inline-flex items-center gap-1.5 mt-3 px-4 py-2 bg-amber-600 text-white text-sm font-medium rounded-lg hover:bg-amber-700 transition-colors"
        >
          <Crown className="w-4 h-4" />
          Mejorar mi plan
        </Link>
      </div>
    </div>
  );
}
